<template>
  <div class="box11">
    <pageTitle title="常见问题" text />

    <commomProblem
      class="box"
      :problemData="problemData"
      :styleData="styleData"
    />
    <div class="btn" @click="zixun('了解更多')">了解更多</div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import commomProblem from "../common/commom-problem.vue";
export default {
  components: {
    pageTitle,
    commomProblem,
  },
  data() {
    return {
      problemData: [
        {
          title: "没有基础可以学会嘛?",
          answer: [
            "可以学习，课程内容和服务项目，是专门为0基础同学设计的。",
          ]
        },
        {
          title: "课程要学习多长时间?",
          answer: [
            "我们会给每个学员制定高效的学习计划，提升学习效率，缩短学习周期，在保证效果的前提下大概需要6个月左右可就业。", 
          ]
        },
        {
          title: "尊享无忧班是怎么保证学习效率的呢?",
          answer: [
            "1. 老师会给定制专属个性化学习计划，带你快速学习就业课程；", 
            "2. 对于课程的重难点、课程类型（比如了解、掌握、应用等）会告诉你哪些可以倍速学习。",
          ]
        },
        {
          title: "就业班和自己看视频有什么区别?",
          answer: [
            "1. 老师会给每一个学员制定专属的学习计划，课后有技术老师答疑解惑，高效学习的基础上缩短学习周期；", 
            "2. 课程中每个阶段都有测评题、阶段作业题，课程案例和项目练习等，能保证很好的学习效果；",
            "3. 给每一个学员360°的就业服务保障，帮助学员能高薪就业。",
          ]
        },
        {
          title: "都学哪些项目? 含金量高吗？",
          answer: [
            "课程中包含3个华为大奖项目（面试通、美蔻商城、翼康养老），其中，面试通项目入驻华为商店，经过华为审核和真实的市场检验，项目含金量遥遥领先，要学鸿蒙应用开发，就要学华为认可和真实上架的鸿蒙项目！具体项目详情请询问咨询老师。",
          ]
        },
      ],
      styleData: {
        iconQuestion: require("../../../assets/coursePage/java/box11/icon.png"),
      },
    };
  },
  methods: {
    zixun(name) {
      this.mai("鸿蒙-就业课","了解更多",0,null)
      this.clickZiXun()
    },
  },
};
</script>

<style lang="scss" scoped>
.box11 {
  padding: 80px 0px 88px;
  width: 100%;
  background: url("../../../assets/coursePage/java/box11/bgc.png") no-repeat;
  background-size: cover;
  .box {
    margin-top: 48px;
  }
  .btn {
    margin: 50px auto 0;
    width: 570px;
    height: 88px;
    background: linear-gradient(0deg, #FF6C47 1%, #FF5A47 100%);
    border-radius: 44px;
    font-weight: 600;
    font-size: 30px;
    color: #FFFFFF;
    line-height: 88px;
    text-align: center;
  }
}
</style>
